import { SeparateLabelsState } from "@redotech/redo-return-ui/flows/return-flow/separate-labels";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SeparateLabelsDetails = memo(function SeparateLabelsDetails(
  _props: StepTypeDetailsProps<SeparateLabelsState>,
) {
  return (
    <Text fontSize="xs">
      This step will create an individual shipping label for each item.
    </Text>
  );
});
